<template>
  <div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" style="background-image: url('/resource_social22/img/fudan_polyu.png')"></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <v-form>
            <card type="login" plain>
              <fg-input
                  class="no-border input-lg"
                  addon-left-icon="now-ui-icons ui-1_email-85"
                  placeholder="Email..."
                  label="Email"
                  v-model="loginUser.email"
              >
              </fg-input>

              <fg-input
                  class="no-border input-lg"
                  addon-left-icon="now-ui-icons objects_key-25"
                  placeholder="Password..."
                  label="Password"
                  type="password"
                  v-model="loginUser.password"
              >
              </fg-input>

              <template slot="raw-content">
                <div  class="card-footer text-center" v-if="isLogining">
                  <n-button type="primary" round class="category" style="width: 100%" disabled>
                    <i class="now-ui-icons animate loader_gear spin" aria-hidden="true"></i>
                  </n-button>
                </div>
                <div class="card-footer text-center" v-else>
                  <n-button type="primary" round @click="login()" class="category" style="width: 100%">Login</n-button>
                  <!--                  <a href="" class="btn btn-primary btn-round btn-lg btn-block" @click="login()">Login</a>-->
                </div>
                <div class="pull-center">
                  <h6>
                    <router-link to="/regist">Regist for Shared Tasks</router-link>
                  </h6>
                </div>
                <div v-if="isError">
                  {{ errorMessage }}
                </div>
              </template>
            </card>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Card, Button, FormGroupInput} from '@/components';
import MainFooter from '@/layout/MainFooter';

export default {
  name: "indexLogin",
  bodyClass: 'login-page',
  components: {
    Card,
    // MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      // 状态变量
      isLogining: false,
      isError: false,
      errorMessage: '',

      // 存储登录用户信息
      loginUser: {
        email: '',
        password: '',
      }
    }
  },

  methods: {


    login() {
      this.isLogining = true;
      this.errorMessage = '';
      this.isError = false;
      var userData = JSON.stringify(this.loginUser);
      this.$http.post("/apisocial22/login/", userData, {
        headers: {
          'X-CSRFToken': null,
          'content-type': 'application/json'
        }
      })
          .then(response => {
            var data = response.data;
            console.log(data);
            // self.alert.success({message: '<strong>这是 <i>HTML</i> 片段</strong>'})
            if (data.loginStatus == "success") {
              this.isLogining = false;
              // 在 localStorage 中添加用户信息 (除非被清除, 否则永久保存, 避免使用)
              localStorage.clear()
              localStorage.setItem('is_login', true);
              localStorage.setItem('token', data.token);
              localStorage.setItem('loginTime', data.loginTime);
              localStorage.setItem('email', data.userInfo.email);
              localStorage.setItem('uni_org', data.userInfo.uni_org);
              localStorage.setItem('team_name', data.userInfo.team_name);
              this.$store.commit('addLoginInfo');
              // 跳转到后台管理界面
              this.$router.push('/console');
              // window.location.reload();
              // this.$router.push('/console')
            } else {
              // 显示错误信息
              this.isLogining = false;
              this.isError = true;
              this.errorMessage = response.data.loginStatus;
            }
          })

    }
  }
}
</script>

<style scoped>

</style>